import React, { useRef, useState } from "react";

const ZOOM = 3; // zoom level (increase for more magnification)
const PANE_W = 600; // zoom pane width in px
const PANE_H = 420; // zoom pane height in px

const MyReactImageMagnify = ({ image }) => {
  const imgRef = useRef(null);
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0, w: 0, h: 0, lw: 0, lh: 0 });

  const handleMove = (e) => {
    if (!imgRef.current) return;
    const rect = imgRef.current.getBoundingClientRect();

    // lens is never larger than the displayed image
    const lw = Math.min(PANE_W / ZOOM, rect.width);
    const lh = Math.min(PANE_H / ZOOM, rect.height);

    // keep lens centred on the cursor, but inside the image
    let x = e.clientX - rect.left - lw / 2;
    let y = e.clientY - rect.top - lh / 2;
    x = Math.max(0, Math.min(x, rect.width - lw));
    y = Math.max(0, Math.min(y, rect.height - lh));

    setPos({ x, y, w: rect.width, h: rect.height, lw, lh });
  };

  return (
    <div className="magnify_wrapper">
      <div
        className="magnify_box"
        onMouseEnter={(e) => {
          setShow(true);
          handleMove(e);
        }}
        onMouseLeave={() => setShow(false)}
        onMouseMove={handleMove}
      >
        <img ref={imgRef} src={image} alt="product" draggable={false} />

        {show && (
          <div
            className="magnify_lens"
            style={{
              width: pos.lw,
              height: pos.lh,
              transform: `translate(${pos.x}px, ${pos.y}px)`,
            }}
          />
        )}
      </div>

      {show && (
        <div
          className="magnify_pane"
          style={{
            width: PANE_W,
            height: PANE_H,
            backgroundImage: `url(${image})`,
            backgroundSize: `${pos.w * ZOOM}px ${pos.h * ZOOM}px`,
            backgroundPosition: `-${pos.x * ZOOM}px -${pos.y * ZOOM}px`,
          }}
        />
      )}
    </div>
  );
};

export default MyReactImageMagnify;